import { FC } from 'react';
import { HeaderProps } from 'react-big-calendar';

import dateService from '@gem/services/date-service';
import { isRussianLocale } from '@gem/utils';

import { capitalizeFirstLetter } from 'APP/utils/calendar/capitalizeFirstLetter';
import { getLanguage } from 'APP/utils/getLanguage';

export const MonthHeader: FC<HeaderProps> = ({ date }) => {
  const dayNameShort = dateService.format(date, { weekday: 'short' });

  return (
    <div className="month-day-name-header">
      {isRussianLocale(getLanguage())
        ? capitalizeFirstLetter(dayNameShort, getLanguage())
        : dayNameShort}
    </div>
  );
};
